export enum TABLE_HEADER {
  PRODUCT = 'Products',
  PLAN = 'Plan',
  LAST_MODIFIED = 'Last modified',
  PARTNER_DISCOUNT = 'Partner discount',
  APPS = 'Apps',
}

export enum CATALOGUE_PAGE_SIDEBARS {
  PRODUCT_PRICING_PLAN = 'edit-invoice-group',
}
